import '../js/core';
import '../css/main.css';

import '../images/th_project_jb_1_small.jpg';
import '../images/th_project_jb_3_small.jpg';
import '../images/th_project_jb_4_small.jpg';

import '../images/th_project_am_1_small.jpg';
import '../images/th_project_am_2_small.jpg';
import '../images/th_project_am_3_small.jpg';

import '../images/th_project_kh_6_small.jpg';
import '../images/th_project_kh_2_small.jpg';
import '../images/th_project_kh_3_small.jpg';

import '../images/th_project_av_1_small.jpg';
import '../images/th_project_av_2_small.jpg';

import '../images/th_project_ml_2_small.jpg';
import '../images/th_project_ml_5_small.jpg';
import '../images/th_project_ml_15_small.jpg';

import '../images/th_project_bl_16_medium.jpg';
import '../images/th_project_bl_10_medium.jpg';
import '../images/th_project_bl_5_medium.jpg';

import '../images/th_project_ea_1_small.jpg';
import '../images/th_project_ea_6_small.jpg';
import '../images/th_project_ea_3_small.jpg';

import '../images/th_project_rp_5_medium.jpg';
import '../images/th_project_rp_3_medium.jpg';
import '../images/th_project_rp_4_medium.jpg';

import '../images/th_project_iy_2_medium.jpg';
import '../images/th_project_iy_3_medium.jpg';
import '../images/th_project_iy_4_medium.jpg';

import '../images/th_project_ba_2_medium.jpg';
import '../images/th_project_ba_3_medium.jpg';
import '../images/th_project_ba_1_medium.jpg';

import '../images/th_project_hv_2_medium.jpg';
import '../images/th_project_hv_3_medium.jpg';
import '../images/th_project_hv_1_medium.jpg';

import '../images/th_project_is_2_medium.jpg';
import '../images/th_project_is_3_medium.jpg';
import '../images/th_project_is_6_medium.jpg';

// Image modal
const modal = document.getElementById('modal');
const modalImg = document.getElementById('modal-img');

document.querySelectorAll('.enlarge-img').forEach((item) => {
  item.addEventListener('click', () => {
    modalImg.src = item.src;
    modal.style.display = 'block';
  });
});

// Projects
const projectJB = document.getElementById('project-jb');

if (projectJB) {
  projectJB.addEventListener('click', () => {
    window.location.href = '/realisaties/project-jb';
  });
}

const projectAM = document.getElementById('project-am');

if (projectAM) {
  projectAM.addEventListener('click', () => {
    window.location.href = '/realisaties/project-am';
  });
}

const projectAV = document.getElementById('project-av');

if (projectAV) {
  projectAV.addEventListener('click', () => {
    window.location.href = '/realisaties/project-av';
  });
}

const projectEA = document.getElementById('project-ea');

if (projectEA) {
  projectEA.addEventListener('click', () => {
    window.location.href = '/realisaties/project-ea';
  });
}

const projectKH = document.getElementById('project-kh');

if (projectKH) {
  projectKH.addEventListener('click', () => {
    window.location.href = '/realisaties/project-kh';
  });
}

const projectML = document.getElementById('project-ml');

if (projectML) {
  projectML.addEventListener('click', () => {
    window.location.href = '/realisaties/project-ml';
  });
}

const projectBL = document.getElementById('project-bl');

if (projectBL) {
  projectBL.addEventListener('click', () => {
    window.location.href = '/realisaties/project-bl';
  });
}

const projectRP = document.getElementById('project-rp');

if (projectRP) {
  projectRP.addEventListener('click', () => {
    window.location.href = '/realisaties/project-rp';
  });
}

const projectBA = document.getElementById('project-ba');

if (projectBA) {
  projectBA.addEventListener('click', () => {
    window.location.href = '/realisaties/project-ba';
  });
}

const projectHV = document.getElementById('project-hv');

if (projectHV) {
  projectHV.addEventListener('click', () => {
    window.location.href = '/realisaties/project-hv';
  });
}

const projectIS = document.getElementById('project-is');

if (projectIS) {
  projectIS.addEventListener('click', () => {
    window.location.href = '/realisaties/project-is';
  });
}

const projectIY = document.getElementById('project-iy');

if (projectIY) {
  projectIY.addEventListener('click', () => {
    window.location.href = '/realisaties/project-iy';
  });
}

// import gsap from 'gsap';
// import { ScrollTrigger } from 'gsap/ScrollTrigger';

// // gsap.registerPlugin(ScrollTrigger);

// // gsap.utils.toArray('.project').forEach((project) => {
// //   const anim = gsap.fromTo(project, { opacity: 0 }, { opacity: 1 });

// //   ScrollTrigger.create({
// //     trigger: project,
// //     animation: anim,
// //     toggleActions: 'play none none none',
// //     start: 'top 90%',
// //     end: 'center 70%',
// //   });
// // });
